/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import * as React from 'react';
import { Modal, ActionButton } from '@blend/enterprise-components';
import { StyleSheet, css } from 'aphrodite';

import { ModalContent } from 'id-components/ModalContent';

const CONFIRM_MFA_OPT_OUT = 'it-ConfirmMFAOptOutModal';

export const styles = StyleSheet.create({
  buttonWrapper: {
    marginBottom: '10px',
  },
});

export namespace ConfirmMFAOptOutModal {
  export interface Props {
    handleClose: () => void;
    handleSubmit: () => void;
    isOpen: boolean;
  }
}

export const ConfirmMFAOptOutModal: React.FC<ConfirmMFAOptOutModal.Props> = ({ isOpen, handleSubmit, handleClose }) => (
  <Modal contentLabel="Confirm MFA opt out" handleClose={handleClose} isOpen={isOpen}>
    <ModalContent
      id={CONFIRM_MFA_OPT_OUT}
      handleClose={handleClose}
      headerText="Are you sure you want to decline 2-step verification?"
    >
      <div className={css(styles.buttonWrapper)}>
        <ActionButton
          id={`${CONFIRM_MFA_OPT_OUT}-submit`}
          label={'Decline 2-step verification'}
          onClick={handleSubmit}
          theme={'primary'}
          isFullWidth={true}
          btnSize={'lg'}
        />
      </div>
      <div className={css(styles.buttonWrapper)}>
        <ActionButton
          id={`${CONFIRM_MFA_OPT_OUT}-cancel`}
          label={'Cancel'}
          onClick={handleClose}
          theme={'tertiary'}
          isFullWidth={true}
          btnSize={'lg'}
        />
      </div>
    </ModalContent>
  </Modal>
);

ConfirmMFAOptOutModal.displayName = 'ConfirmMFAOptOutModal';
